import React from 'react';

export const Logo = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 57.6 35.2"
    role="img"
    {...props}
  >
    <title>VA</title>
    <g fill="#FFF">
      <path d="M11.1 35.2L0 0h8.6l4.2 14.9c1.2 4.2 2.2 8.2 3.1 12.6h.1c.9-4.2 1.9-8.4 3.1-12.4L23.5 0h8.3L20.2 35.2h-9.1zM36.6 26.2l-2.5 9h-8L36.6 0h10.2l10.8 35.2h-8.5l-2.7-9h-9.8zm8.8-6l-2.2-7.5c-.6-2.1-1.2-4.7-1.7-6.8h-.1c-.5 2.1-1 4.8-1.6 6.8l-2 7.5h7.6z" />
    </g>
  </svg>
);

export default Logo;
